import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=b83e30be&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83e30be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b83e30be')) {
      api.createRecord('b83e30be', component.options)
    } else {
      api.reload('b83e30be', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=b83e30be&scoped=true&", function () {
      api.rerender('b83e30be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N8wOl4QNak5Y/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports